










































































































import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Checkbox from "@/shared/components/ui/Checkbox.vue";

@Component({
  components: {
    Button,
    Checkbox
  }
})
export default class TrusteeToTrusteeTransferDetailsV2 extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  get nextDisabled () {
    return this.$validator.errors.any();
  }

  get accountNumberValidation () {
    return {
      max: 20,
      alpha_num: true,
      required: !this.balanceTransferStore.isAccountNumberUnknown
    };
  }

  onUnknownAccountNumberChanged () {
    this.balanceTransferStore.isAccountNumberUnknown = !this.balanceTransferStore.isAccountNumberUnknown;
  }

  onTransferEntireBalanceChanged () {
    this.$validator.errors.remove("transferBalance");
    this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance = !this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance;
    if (this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance && this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance) {
      this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance = false;
      this.balanceTransferStore.trusteeToTrusteeDetails.amount = 0;
    }
  }

  onTransferPartialBalanceChanged () {
    this.$validator.errors.remove("transferBalance");
    this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance = !this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance;
    if (this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance && this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance) {
      this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance = false;
    }
  }

  goBack () {
    this.$validator.errors.remove("transferBalance");
    this.balanceTransferStore.goToStep("trustee-provider");
  }

  onSubmit () {
    this.$validator.validate()
        .then(isValid => {
          if (!this.balanceTransferStore.isCustodianUnknown && !this.balanceTransferStore.transferBalanceOptionSelected) {
            this.$validator.errors.add({
              field: "transferBalance",
              msg: "Please choose an option."
            });

            return;
          }

          if (!isValid) {
            return;
          }

          if (this.balanceTransferStore.canESign) {
            this.balanceTransferStore.getTrusteeToTrusteeBalanceTransferSigningModel().then(() => {
              this.balanceTransferStore.goToStep("trustee-form-signature");
            });
          } else {
            this.balanceTransferStore.goToStep("trustee-download");
          }
        });
  }
}
